var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticStyle:{"display":"visible"}},[_c('div',{class:{
      'rounded-div': _vm.data.styles.selectedShape === 'circle',
      'rectangle-div': _vm.data.styles.selectedShape === 'rectangle'
    },style:(_vm.getElementStyle)},[_c('div',{staticClass:"icon-container"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.iconContent)}})])]),_c('div',[(_vm.isActive|| _vm.isDataTableField)?_c('span',{staticClass:"setting-icon"},[_c('i',{staticClass:"el-icon-s-tools",on:{"click":_vm.openSettings}})]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }